var render = function render(){var _vm=this,_c=_vm._self._c;return _c('formItemClick',{attrs:{"routerName":_vm.routerName,"routerQuery":_vm.routerData,"routeFunction":_vm.routeFunction,"typeOrder":_vm.typeOrder,"ifColor":_vm.dispose},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }